export const NumericPillTestAttributes = {
    text: 'numeric-pill-text',
};
